// src/services/streamAgent.js
import { fetchEventSource } from '@microsoft/fetch-event-source';

export default function streamAgent({
  url,
  token,
  payload,
  signal,
  onEvent,
  onError,
}) {
  return fetchEventSource(url, {
    method: 'POST',
    headers: {
      Accept: 'text/event-stream',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
    signal,
    openWhenHidden: true,
    async onopen(response) {
      if (!response.ok) {
        const error = await response.json().catch(() => null);
        throw new Error(error?.message || `HTTP ${response.status}`);
      }
      if (!response.headers.get('content-type')?.includes('text/event-stream')) {
        throw new Error('The server did not return a chat stream.');
      }
    },
    onmessage(event) {
      let data = null;
      try {
        data = event.data ? JSON.parse(event.data) : null;
      } catch {
        data = event.data;
      }

      onEvent({
        type: event.event || 'message',
        data,
      });
    },
    onerror(err) {
      if (onError) onError(err);
      throw err;
    },
  });
}
